import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { UserContext } from '../../../objects/Context';
import { WorkspaceContext } from '../../../objects/Context';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/arrow-right-icon.svg';
import './SettingsMenu.css';

function SettingsMenu({ onMenuItemSelect, selectedMenuItem }) {
  const { user } = useContext(UserContext);
  const { workspace } = useContext(WorkspaceContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(selectedMenuItem || 'profile');

  // Update active menu when selectedMenuItem prop changes
  useEffect(() => {
    if (selectedMenuItem && selectedMenuItem !== activeMenu) {
      setActiveMenu(selectedMenuItem);
    }
  }, [selectedMenuItem]);

  const menuSections = [
    {
      title: 'Settings',
      items: [
        { label: 'Your Profile', key: 'profile' }
      ]
    },
    {
      title: 'Organization',
      items: [
        { label: 'General', key: 'org-general' },
        { label: 'Branding', key: 'org-branding' },
        { label: 'Members', key: 'members' },
        { label: 'Billing & Invoices', key: 'subscription' }
      ]
    },
    {
      title: 'Workspace',
      items: [
        { label: 'General', key: 'workspace-general' },
      ]
    }
  ];

  const handleNavigation = (key) => {
    if (activeMenu !== key) {
      setActiveMenu(key);
      // Call the callback function to notify parent component
      if (onMenuItemSelect) {
        onMenuItemSelect(key);
      }
    }
  };

  const handleBackToApp = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div className={`settings-menu`}>
        {/* <div className="settings-menu-header" onClick={handleBackToApp}>
            <ArrowIcon className="arrow-icon" />
            <div className="settings-menu-header-text">Back to App</div>
        </div> */}
      {menuSections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="menu-section">
          <h3 className="section-title">{section.title}</h3>
          <ul>
            {section.items.map((item, index) => (
              <li key={index} className={`menu-item ${activeMenu === item.key ? 'active' : ''}`}>
                <div className="menu-item-link" onClick={() => handleNavigation(item.key)}>
                  <p className={`menu-label ${activeMenu === item.key ? 'active' : ''}`}>{item.label}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default SettingsMenu;